import React from 'react'
import Navbar from './Navbar';
import Cookies from 'js-cookie';
const About = () => {
  const accessToken = Cookies.get('accessToken');
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div style={{marginTop : "250px"}}>
        <h1 className='flex justify-center text-3xl'>About us</h1>
      </div>
    </div>
  )
}

export default About;